module.exports = __webpack_public_path__ + "img/twitter.79b9a838.svg";